import { User } from "@auth0/auth0-react";

export function getClaimUserId(auth0User: User): string {
  return auth0User["http://infostat.se/claims/customerServiceUserId"];
}
